import React from 'react';
import { View } from 'react-native';
import { useTheme, StatusBadge, Icons } from '@hmsexp/component-library';

const AlertsBadge = ({ alertStatus, alertType, alertBadgeMapping = [] }) => {
  const { palette } = useTheme();

  const formatText = value => {
    if (!value) return '';

    if (Array.isArray(alertBadgeMapping)) {
      const match = alertBadgeMapping.find(item => item.key === value);
      if (match && match.label) {
        return match.label;
      }
    }
    
    return '';
  };

  const getBackgroundColor = value => {
    if (!value) return palette.cautionBackgroundLow;

    if (Array.isArray(alertBadgeMapping)) {
      const match = alertBadgeMapping.find(item => item.key === value);
      if (match && match.color && palette[match.color]) {
        return palette[match.color];
      }
    }
    
    return palette.cautionBackgroundLow;
  };

  const renderIcon = () => {
    return (
      <>
        <Icons.BellIcon size='M' />
      </>
    );
  };
  return (
    <View>
      <StatusBadge
        style={{
          textStyle: {
            color: palette.primaryContentHigh
          },
          contentWrapper: {
            marginHorizontal: '10px'
          },
          titleContainer: {
            marginBottom: 0
          },
          subtitleContainer: {
            marginTop: 0
          },
          wrapper: {
            display: 'flex',
            alignItems: 'center',
            height: '50px',
            padding: '10px',
            backgroundColor: getBackgroundColor(alertStatus)
          }
        }}
        subtitle={formatText(alertType)}
        title={formatText(alertStatus)}
        renderIcon={renderIcon}
      />
    </View>
  );
};

export default AlertsBadge;
